import { IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
import { AccountInfo } from '@src/types/account'
import { getReferralCode } from '@src/utils/jwt'
import { telegramLogin } from '@src/service/auth'
import Iconify from '../iconify'

const TelegramLogin: React.FC<{ loginSuccess: (data: AccountInfo) => void }> = ({
  loginSuccess,
}) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?7'
    script.async = true
    script.onload = () => setReady(true)
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const handleLogin = () => {
    const botId = process.env.REACT_APP_TG_LOGIN_BOT
    if (!botId || !window.Telegram?.Login?.auth) {
      console.warn('Telegram Login not ready or botId is missing.')
      return
    }

    window.Telegram.Login.auth(
      {
        bot_id: botId.toString(),
        request_access: true,
      },
      async (values) => {
        if (!values) {
          console.warn('Authorization failed.')
          return
        }

        const { first_name, last_name, auth_date, photo_url, username, ...other } = values
        const params = {
          firstName: first_name || '',
          lastName: last_name || '',
          authDate: auth_date || 0,
          photoUrl: photo_url || '',
          username: username || '',
          ...other,
        }
        const referralCode = getReferralCode()
        const { code, data } = await telegramLogin(
          referralCode
            ? {
                ...params,
                referralCode,
              }
            : params,
        )
        console.warn('Telegram user info received:', data)

        if (code !== 0) return
        loginSuccess(data)
      },
    )
  }

  return (
    <>
      <IconButton
        onClick={handleLogin}
        disabled={!ready}
        sx={{ border: '1px solid #e8ecee', width: 48, height: 48 }}
      >
        <Iconify icon='logos:telegram' sx={{ width: 28, height: 28 }} />
      </IconButton>
    </>
  )
}

export default TelegramLogin
